//
import ContractPeriodModel from '@/models/HumanResource/HrContractPeriod'
import ContractTypeModel from '@/models/HumanResource/HrContractType'
import EmployeeModel from '@/models/HumanResource/HrEmployee'

// hr_employee_id, hr_contract_type_id, hr_contract_period_id, active
export default [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name_case',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
        },
    },
    {
        name: 'hr_contract_period_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Periodo',
            model: ContractPeriodModel,
            noObject: true,
            paramSearch: 'name',
        },
    },
    {
        name: 'hr_contract_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Tipo',
            model: ContractTypeModel,
            noObject: true,
            paramSearch: 'name',
        },
    },
    {
        name: 'active',
        type: 'select',
        props: {
            clearable: true,
            items: [
                {
                    text: 'Si',
                    value: true,
                },
                {
                    text: 'No',
                    value: false,
                },
            ],
            label: 'Activo',
        },
    },
]